import * as React from "react"
import { Link, Spacer, Tooltip, ThemeCss } from "gatsby-interface"
import { MdInfoOutline } from "react-icons/md"
import { getPathToOrgSettings } from "@modules/organization/shared/utils"

export type FeatureUsageInfoProps = {
  organizationId: string
  isRecalculating: boolean
  message: React.ReactNode
}

export function FeatureUsageInfo({
  organizationId,
  isRecalculating,
  message,
}: FeatureUsageInfoProps) {
  const pathToOrganizationUsage = `${getPathToOrgSettings(
    organizationId
  )}/general#usage`

  return (
    <div css={rootCss}>
      <span css={theme => [isRecalculating && recalculatingCss(theme)]}>
        {isRecalculating ? `Updating ...` : message}
      </span>

      <Spacer direction="horizontal" size={2} />

      <Tooltip label="Usage is measured per workspace">
        <span>
          <Link to={pathToOrganizationUsage} variant="SIMPLE">
            <MdInfoOutline />
          </Link>
        </span>
      </Tooltip>
    </div>
  )
}

/* styles */

const rootCss: ThemeCss = theme => ({
  display: `inline-flex`,
  alignItems: `center`,
  fontSize: theme.fontSizes[1],
  color: theme.colors.grey[60],
  lineHeight: 1,
  minHeight: theme.space[8],

  span: {
    display: `inline-flex`,
  },

  svg: {
    width: theme.space[5],
    height: theme.space[5],
  },
})

const recalculatingCss: ThemeCss = theme => ({
  color: theme.colors.grey[50],
  fontStyle: `italic`,
})
